import type { Customer } from '@payaca/types/customerTypes';
import type { Deal } from '@payaca/types/dealTypes';
import { JobActionType } from '@payaca/types/jobActionsTypes';
import type { Job } from '@payaca/types/jobTypesV2';
import {
  canDuplicateJob,
  canEditSentJob,
  canMarkJobAsAccepted,
  canMarkJobAsDeclined,
  canResendJob,
  canUnacceptProposal,
} from './jobHelperV2';
import { jobHasSent } from './jobStatusHelper';

export const getAvailableActionsForJob = (
  job: Job,
  deal: Deal,
  customer: Customer
): JobActionType[] => {
  const jobActionTypes: JobActionType[] = [];

  // A Proposal on a v1 Project is read only.
  if (deal.version < 2) return jobActionTypes;

  if (job.inactivatedAt) return jobActionTypes;

  if (job.isProtoInvoice) {
    if (!job.sentAt) {
      jobActionTypes.push(JobActionType.EDIT);
      jobActionTypes.push(JobActionType.SEND);
      jobActionTypes.push(JobActionType.MARK_AS_SENT);
    }
    return jobActionTypes;
  }

  if (!jobHasSent(job.status)) {
    jobActionTypes.push(JobActionType.EDIT);
    jobActionTypes.push(JobActionType.SEND);
    jobActionTypes.push(JobActionType.MARK_AS_SENT);
    return jobActionTypes;
  }

  if (canMarkJobAsAccepted(job)) {
    jobActionTypes.push(JobActionType.MARK_AS_ACCEPTED);
  }
  if (canMarkJobAsDeclined(job)) {
    jobActionTypes.push(JobActionType.MARK_AS_DECLINED);
  }
  if (canDuplicateJob(job)) {
    jobActionTypes.push(JobActionType.DUPLICATE);
  }
  if (canUnacceptProposal(job, [], !!deal.changeProposalIds.length)) {
    jobActionTypes.push(JobActionType.REMOVE_ACCEPTED);
  }
  if (canResendJob(job, customer, false)) {
    jobActionTypes.push(JobActionType.RESEND);
  }
  if (canEditSentJob(job, [], false)) {
    jobActionTypes.push(JobActionType.INACTIVATE_AND_EDIT);
  }

  return jobActionTypes;
};
